export const collection = 'meat_checklist';
